<template lang="html">

  <div class="contenedor-espiral">
    <img src="/static/img/espiral.png" alt="espiral" class="gif">
  </div>

</template>

<script lang="js">
  export default  {
    name: 'espiral',
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/parts/icons/espiral.vue